declare namespace $ {

	export class $mol_icon_palette extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=palette.view.tree.d.ts.map